'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@common/components';
import type { ReactNode } from 'react';
import type { RouletteItem } from '../_hooks/useRouletteDetail';

//* 접어 두면 확률을 숨긴 것으로 읽힌다 — 셋 다 펼친 채로 연다.
const NOTICE_VALUES = ['prizes', 'probability', 'cautions'];
const NoticeList = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ul className="flex flex-col gap-8 font-400 text-Gray-600 typo-caption1 [&>li]:flex [&>li]:gap-8 before:[&>li]:mt-8 before:[&>li]:size-[3px] before:[&>li]:shrink-0 before:[&>li]:rounded-xxsmall before:[&>li]:bg-Gray-500 before:[&>li]:content-['']">{children}</ul>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const NoticeTitle = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="font-700 text-Gray-600 typo-body4">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
interface RouletteNoticesProps {
  items: RouletteItem[];
  blankProbability?: number | null;
}
export const RouletteNotices = t0 => {
  const $ = _c(21);
  const {
    items,
    blankProbability
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== items) {
    const prizeNames = items.filter(_temp).map(_temp2);
    T0 = Accordion;
    t1 = true;
    t2 = NOTICE_VALUES;
    t3 = "px-24 mobile-tablet:px-20";
    t4 = prizeNames.length > 0 ? <Accordion.Item value="prizes" className="border-b-0"><Accordion.Trigger title={<NoticeTitle>당첨 쿠폰</NoticeTitle>} hoverFeedback="icon" className="mt-12 p-0" /><Accordion.Content className="px-0"><NoticeList><li>{prizeNames.join(", ")} 중 하나</li></NoticeList></Accordion.Content></Accordion.Item> : null;
    $[0] = items;
    $[1] = T0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    T0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Accordion.Trigger title={<NoticeTitle>룰렛 당첨 확률 안내</NoticeTitle>} hoverFeedback="icon" className="mt-12 p-0" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li className="whitespace-pre-line">{"\uCFE0\uD3F0\uB9C8\uB2E4 \uB2F9\uCCA8 \uD655\uB960\uC774 \uC870\uAE08\uC529 \uB2EC\uB77C\uC694.\n\uC544\uC27D\uAC8C \uC548 \uB098\uC624\uBA74 \uCCAB \uBC88\uC9F8 \uC7AC\uB3C4\uC804\uC740 \uBB34\uB8CC, \uB450 \uBC88\uC9F8\uB294 \uAD11\uACE0\uB97C \uBCF4\uBA74 \uD560 \uC218 \uC788\uC5B4\uC694\n(\uC81C\uD734\uD3EC\uC778\uD2B8\uB294 \uB354 \uB4E4\uC9C0 \uC54A\uC544\uC694)"}</li>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== blankProbability) {
    t7 = typeof blankProbability === "number" ? <li>꽝 확률은 {blankProbability}%예요.</li> : null;
    $[8] = blankProbability;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <Accordion.Item value="probability">{t5}<Accordion.Content className="px-0"><NoticeList>{t6}{t7}</NoticeList></Accordion.Content></Accordion.Item>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Accordion.Trigger title={<NoticeTitle>유의사항</NoticeTitle>} hoverFeedback="icon" className="mt-16 p-0" />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Accordion.Item value="cautions">{t9}<Accordion.Content className="px-0"><NoticeList><li>쿠폰별 제공 확률은 내부 기준에 따라 차등 적용될 수 있어요</li><li>룰렛에 포함되는 쿠폰은 사전 고지 없이 변경될 수 있어요</li><li>지급된 모바일 쿠폰은 유효기간 연장·환불이 불가하며 받은 날부터 30일 이내 사용할 수 있어요</li><li>당첨된 쿠폰은 바로 내 쿠폰함으로 보내 드려요. 쿠폰이 단종되거나 품절되면 동일·유사 쿠폰으로 대체될 수 있어요.</li><li className="font-700 text-R-600">미당첨이어도 차감된 제휴포인트는 돌려받을 수 없어요</li></NoticeList></Accordion.Content></Accordion.Item>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== T0 || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t8) {
    t11 = <T0 multiple={t1} defaultValues={t2} className={t3}>{t4}{t8}{t10}</T0>;
    $[14] = T0;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
function _temp(item) {
  return !item.blankYN && item.name;
}
function _temp2(item_0) {
  return item_0.name;
}